import {User} from '../models';

export class AuthState {
  user: User;
  isLoading: boolean;
  error: string;
}
